import {diagrams} from './diagrams';
import {modals} from './modals';

export default {
  modals,
  diagrams,
};
